// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: 'assets/archive',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-assets" */ '@/pages/[organisation]/hr/team-member-assets/archived-team-member-assets.vue'),
        name: 'human-resource.team-member-assets.archived-team-member-assets',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.asset.update-team-member-asset',
        },
    },
    {
        path: 'assets/archive/:assetId',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-assets" */ '@/pages/[organisation]/hr/team-member-assets/archived-team-member-asset/[id].vue'),
        name: 'human-resource.team-member-assets.view-archived-team-member-asset',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.asset.update-team-member-asset',
        },
    },

    {
        path: 'assets',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-assets" */ '@/pages/[organisation]/hr/team-member-assets/team-member-assets.vue'),
        name: 'human-resource.team-member-assets.search-team-member-assets',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.asset.view-team-member-assets',
        },
    },
    {
        path: 'assets/new',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-assets" */ '@/pages/[organisation]/hr/team-member-assets/team-member-asset/new.vue'),
        name: 'human-resource.team-member-assets.create-team-member-asset',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.asset.create-team-member-asset',
        },
    },
    {
        path: 'assets/:assetId',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-assets" */ '@/pages/[organisation]/hr/team-member-assets/team-member-asset/[id].vue'),
        name: 'human-resource.team-member-assets.view-team-member-asset',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.asset.view-team-member-assets',
        },
    },
    {
        path: 'assets/:assetId/edit',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-assets" */ '@/pages/[organisation]/hr/team-member-assets/team-member-asset/[id]/edit.vue'),
        name: 'human-resource.team-member-assets.update-team-member-asset',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.asset.update-team-member-asset',
        },
    },
];
